import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import uploadPhotos from "@/images/Company-logo.svg";
import { useAuth } from '@/AuthProvider';
import roles from '@/constant/roles.config';
import { privateRoutePaths } from '@/routes/private.route.config';
import { buildPath } from '@/utils/common';

function TopCompany({ dashboardData }) {

  const { user, isSuperAdmin, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();


  const [data, setData] = useState([]);

  useEffect(() => {
    if (dashboardData) {
      setData(dashboardData);
    }
  }, [dashboardData]);


   const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

  return (<>
    <div class="row">
      <div class="col-md-12">
        <div className="head underline">
          <h3>Top 5 User visited Profile</h3>
        </div>
        <div class="company-list-wrape">
          {data?.length > 0 ? (
            data.map((member, index) => (
              <div className="company-list-pad" key={index}>
                <div className='company-thumb'>
                  {member.company_logo != null ? (
                    <img src={member.company_logo} alt="Not Found" height={60} />
                  ) : (
                    <img src={uploadPhotos} alt="Not Found" height={60} />
                  )}
                </div>
                <div className='company-detail'>
                  {member.trade_mode_type !== 'LOG_PTR' && (
                    
                  <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: member?.viewed_member_id })}`}  target="_blank">
                      <b>{member.company_name ?? '-'}</b>
                  </Link>
                  )}
                  {member.trade_mode_type === 'LOG_PTR' && (
                  <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_LOGISTIC_PROFILE, { id: member?.viewed_member_id })}`}  target="_blank">
                      <b>{member.company_name ?? '-'}</b>
                  </Link>
                  )}
                  <div className='other-detail'>
                    <p className='address'>{member.city ? member.city + ',' : ''} {member.country ?? ''}</p>
                    <p><b>Orex ID</b> {member.member_unique_number ?? '-'}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="card-body">
              <b>No Data Found</b>
            </div>
          )}
        </div>

      </div>

    </div>
  </>)
}

export default TopCompany
